<template>
  <public-layout>
    <section class="hero hero-header-1">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered">
            <div class="column">
              <p class="product-title">
                Programs
              </p>
              <p class="product-subtitle">
                Empowering children to become whatever they want in life, even an astronaut!
              </p>
              <p class="product-description">
                Designed to encourage children to explore their professional aspirations, discover core strengths and develop key life skills.
                 Includes lesson and activity plans tailored to be integrated into the kindergarten day.
                 Each program embraces a unique theme such as ‘space exploration’.
              </p>
              <p class="product-description"><strong>The Future Astronaut program is under reconstruction. It will be back better than ever. Stay tuned.</strong></p>
              <p class="product-cta">
                <!-- <Button size="large" :to="{ name: 'login', params: { redirect: $route.fullPath } }" v-if="!$store.state.isAuthenticated">Access Now</Button>
                <a href="#programs" class="button button-large button-primary" v-else>Discover our programs</a> -->
                <a href="javascript:;" @click="moreInfo = !moreInfo" class="button button-large button-secondary">{{moreInfo?'Read Less':'Read More'}}</a>
              </p>
            </div>
            <div class="column is-narrow">
              <img class="product-image" src="/static/img/assets/future-explorers.jpg" alt="">
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="hero is-light section-description" v-if="moreInfo">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered has-text-centered">
            <div class="column">
              <p class="subsection-title">
                Children of today are the decision makers of tomorrow
              </p>
              <p class="subsection-subtitle">
                  It helps children understand how the world works today.
                  It guides them to identify their core strengths and develop life skills, needed for the future and a lifetime of learning.
              </p>
            </div>
          </div>

          <section-bullets :items="readMoreItems"></section-bullets>
        </div>
      </div>
    </section>

    <section class="hero section-services" id="programs" :class="{ 'has-top-gray-hero': !moreInfo }">
      <div class="hero-body">
        <div class="container">
          <div class="columns has-text-centered">
            <div class="column">
              <p class="subsection-title">
                <strong>Programs</strong>
              </p>
            </div>
          </div>

          <div class="columns" v-for="(solution, index) in solutions" :key="index">
            <div class="column is-two-thirds" :class="{ 'is-offset-one-third': index % 2 !== 0 }">
                <product-card :data="solution" :isReverse="index % 2 !== 0"></product-card>
            </div>
          </div>

        </div>
      </div>
    </section>

    <section class="hero is-light section-testimonies">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered has-text-centered">
            <div class="column">
              <p>
                “As a teacher, when you embrace the idea that children should have fun while learning, it will also help you.
                 Because Fun Learning becomes fun working. This motivates you to develop yourself even more.”
              </p>
              <small>Olli Kamunen<br><i>Fun Academy Trainer, Director of a Helsinki City Kindergarten and member of Finland Education Advisory Board</i></small>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section-contact>
      <template slot="title">Interested in Fun Academy Programs?</template>
      <template slot="button">Get Started for Free</template>
      <img slot="image" src="static/img/characters/large/soca-2.png"/>
    </section-contact>

  </public-layout>
</template>

<script>
import PublicLayout from '@/layouts/PublicLayout'
import SectionContact from '@/components/SectionContact'
import SectionBullets from '@/components/SectionBullets'
import ProductCard from '@/components/ProductCard'
import Button from '@/components/Button'
import ApiConfig from '@/utils/ApiConfig'

export default {
  name: 'kinderpage',

  components: {
    PublicLayout,
    SectionContact,
    SectionBullets,
    ProductCard,
    Button
  },

  data () {
    return {
      moreInfo: false,
      readMoreItems: [
        `<strong>Each program focuses on skills</strong> children need to succeed in tomorrow’s working environments.`,
        `<strong>Gives educators the freedom and inspiration</strong> to adapt each program to fit the needs of their students, resources available and time frame.`,
        `<strong>Empowers children to shape their future</strong> and face the challenges that lies ahead.`,
        `<strong>Provides an exciting Fun Learning experience</strong> through an array of fun and inspiring themes.`
      ],
      solutions: [
        {
          title: 'Future Astronaut program',
          description: 'A 12-week program that adapts the real NASA Training for astronauts. Based on the Fun Learning approach rooted in Finnish education expertise. Empowers early childhood educators to promote scientific thinking, mindfulness, physical activity and teamwork within their classroom.',
          img: '/static/img/assets/future-astronaut.png',
          to: this.$store.state.isAuthenticated ? { path: `courses/${ApiConfig.AP_ID}/1` } : { name: 'astronaut-program' }
        }
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.product-title{
  color: #0A2239;
  font-size: 2.5rem;
  font-weight: bold;
  line-height: 1.2;
  margin-bottom: 1.125rem;
}

.product-subtitle{
  color: #363636;
  font-size: 1.25rem;
  line-height: 1.6;
}

.product-description{
    color: #6B7285;
    font-size: 1rem;
    margin-top: 2rem;
}

.product-cta{
  margin-top: 1.5rem;
}

.character-correction{
  margin-bottom: -6rem;
}

.subsection-subtitle{
    color: #6B7285;
    font-size: 1rem;
    margin-top: 1.6rem;
}

.section-testimonies{
  p{
    color: #6B7285;
    font-style: italic;
    font-size: 1.625rem;
    line-height: 1.55;
  }
  small{
    display: block;
    font-size: 1rem;
    padding-top: 1rem;

    i{
      color: #6B7285;
    }
  }
}

.section-cta{
  .hero-body{
    padding-bottom: 0;
  }

  .image-wrapper{
    overflow:hidden;
    height: 400px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/FutureExplorersPage.vue